import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { FuseSharedModule } from '@fuse/shared.module';

import { ProjectComponent } from './project.component';
import { ProjectService } from '@fuse/services/project.service';
import { MatButtonModule, MatIconModule, MatDividerModule } from '@angular/material';

const routes = [
    {
        path: 'project/:id',
        component: ProjectComponent,
        pathMatch: 'full',
        resolve: {
            data: ProjectService
        }
    }
];

@NgModule({
    declarations: [
        ProjectComponent
    ],
    imports: [
        RouterModule.forChild(routes),

        TranslateModule,

        FuseSharedModule,

        MatButtonModule,
        MatIconModule,
        MatDividerModule
    ],
    exports: [
        ProjectComponent
    ],
    providers: [
        ProjectService
    ]
})

export class ProjectModule {
}
